export var GridAutosizeColsMode;
(function (GridAutosizeColsMode) {
    GridAutosizeColsMode["none"] = "NOA";
    GridAutosizeColsMode["legacyOff"] = "LOF";
    GridAutosizeColsMode["legacyForceFit"] = "LFF";
    GridAutosizeColsMode["ignoreViewport"] = "IGV";
    GridAutosizeColsMode["fitColsToViewport"] = "FCV";
    GridAutosizeColsMode["fitViewportToCols"] = "FVC";
})(GridAutosizeColsMode || (GridAutosizeColsMode = {}));
//# sourceMappingURL=gridAutosizeColsMode.enum.js.map